import { render, staticRenderFns } from "./ProjectSettingsBtn.vue?vue&type=template&id=06b5adea&scoped=true"
import script from "./ProjectSettingsBtn.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsBtn.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsBtn.vue?vue&type=style&index=0&id=06b5adea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5adea",
  null
  
)

export default component.exports